import { Import } from "../models/Import";
import ProgressBar from "./ProgressBar";

const ImportListItem = ({ importItem }: { importItem: Import }) => {
  if (importItem.status === "completed") return null;
  return (
    <ProgressBar
      message={importItem.statusMessage || getStatusMessage(importItem.status)}
      progress={importItem.progress ?? 0}
    />
  );
};

const getStatusMessage = (status: string): string => {
  switch (status) {
    case "queued":
      return "Queued for processing...";
    case "processing":
      return "Processing import...";
    case "completed":
      return "Import completed ✅";
    case "error":
      return "Import failed ❌";
    default:
      return "Unknown status";
  }
};

export default ImportListItem;
